// Single source of truth for the backend origin used by the frontend.
// Defaults to production so deploys need no build args; for local development
// against a local API, create .env.local with:
//   REACT_APP_BACKEND_URL=http://localhost:7860
export const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL || 'https://backend.blueskyengineering.net';
